import { jwtDecode } from 'jwt-decode';

import { currentJwt } from './jwtHelpers';

const permissionByResource = (resourceType) => {
    switch (resourceType) {
    case 'ProductUpdate':
        return 'product_updates';
    case 'Training':
        return 'trainings';
    case 'JobAid':
        return 'job_aids';
    case 'Webinar':
        return 'webinars';
    case 'Alert':
        return 'alerts';
    case 'UnderwritingGuideline':
        return 'underwriting_guidelines';
    case 'ProgramGuide':
        return 'program_guides';
    case 'RateAndRuleManual':
        return 'rate_bulletins';
    case 'RateBulletin':
        return 'rate_bulletins';
    case 'HomeLink':
        return 'home_links';
    default:
        return null;
    }
};

export const Permissions = (resourceType, action, permissionsObject = null) => {
    const resource = permissionByResource(resourceType);

    if (permissionsObject) {
        if (!permissionsObject[resource]) {
            return true;
        }
        return permissionsObject[resource][action];
    }

    const jwt = currentJwt();

    if (jwt) {
        const decodedJWT = jwtDecode(jwt);

        if (decodedJWT && !decodedJWT.permissions) {
            // old jwt has no permissions
            return true;
        }

        const { permissions } = decodedJWT;

        if (!permissions[resource]) {
            // old jwt has no resource in permissions
            return true;
        }

        return permissions[resource][action];
    }

    return false;
};
